import request from '@/utils/request';
import { datasetEndpoint } from '@/constants/urls';

const updateSettings = (code, updates) => (
  request({
    data: updates,
    method: 'PATCH',
    url: `${datasetEndpoint(code)}/settings`,
  })
);

const settings = (code) => request({
  method: 'GET',
  url: `${datasetEndpoint(code)}/settings`,
});

const DatasetSettingService = {
  settings,
  updateSettings,
};

export default DatasetSettingService;
